export const SET_TOKEN = 'auth/SET_TOKEN'
export const LOGOUT = 'auth/LOGOUT'
